import { Pager } from "../../Shared/scriptts/interfaces";
import { params, displayResults, executeSearchUrl } from "../search-main";

const listItemCss = 'min-w-10 h-10';
const nextPrevListItemCss = 'flex items-center';

/**
 * Returns the HTML for the search results pagination
 * @param pager The Pager object in the search results
 * @returns
 */
export function getSearchResultsPagination(pager: Pager): string {
    if (pager.NumberOfPages < 2) {
        return '';
    }
    let pagerHtml = `<ul class="hidden md:flex items-center mt-6 gap-x-2 justify-center">
        ${pager.HasPreviousPage ? `<li class="${listItemCss} ${nextPrevListItemCss}">${getPreviousButton((pager.CurrentPageIndex - 1).toString(), false)}</li>` : ""}
        ${getPageButton("1", pager.CurrentPageIndex.toString())}
        ${(pager.NumberOfPages > 6 && pager.CurrentPageIndex > 4) ? `<li class=${listItemCss}>&hellip;</li>` : ''}
        ${getMiddlePageButtons(pager.NumberOfPages, pager.CurrentPageIndex, pager.PreviousPageIndex, pager.NextPageIndex, pager.LastPageIndex)}
        ${(pager.NumberOfPages > 6 && pager.CurrentPageIndex < pager.LastPageIndex - 3) ? `<li class=${listItemCss}>&hellip;</li>` : ''}
        ${getPageButton(pager.LastPageIndex.toString(), pager.CurrentPageIndex.toString())}
        ${pager.HasNextPage ? `<li class="${listItemCss} ${nextPrevListItemCss}">${getNextButton((pager.CurrentPageIndex + 1).toString(), false)}</li>` : ""}
        </ul>
    `;
    if (pager.HasPreviousPage || pager.HasNextPage) {
        const justifycss = pager.HasPreviousPage && pager.HasNextPage ? 'justify-between'
                : pager.HasPreviousPage ? 'justify-start'
                : 'justify-end';
        pagerHtml += `<div class="md:hidden flex my-4 px-4 ${justifycss}">`;
        pagerHtml += pager.HasPreviousPage ? getPreviousButton((pager.CurrentPageIndex - 1).toString(), true) : '';
        pagerHtml += pager.HasNextPage ? getNextButton((pager.CurrentPageIndex + 1).toString(), true) : '';
        pagerHtml += '</div>';
    }
    return pagerHtml;
}

/**
 * Adds event handlers to the search results pagination buttons
 * @param paginationElem The HTML element that contains the pagination buttons
 */
export function bindPageButtonEvents(paginationElem: HTMLElement) {
    paginationElem.querySelectorAll<HTMLButtonElement>('[data-page]').forEach(button => {
        button.addEventListener('click', () => {
            params.Page = button.getAttribute('data-page')?.toString() || "1";
            displayResults(executeSearchUrl, true);
            const url = new URL(document.location.toString());
            url.searchParams.set('p', params.Page);
            history.pushState({}, "", url);
        });
    });
}

function getMiddlePageButtons(totalPages: number, currentPage: number, previousPage: number, nextPage: number, lastPage: number): string {
    const currentPageStr = currentPage.toString();
    let pages = '';
    
    if (totalPages > 6) {
        if (currentPage < 5) {
            for (let i = 2; i <= 5; i++) {
                pages += getPageButton(i.toString(), currentPageStr);
            }
        }
        else if (currentPage > 4 && currentPage < lastPage - 3) {
            pages = `${getPageButton(previousPage.toString(), currentPageStr)}
                     ${getPageButton(currentPageStr, currentPageStr)}
                     ${getPageButton(nextPage.toString(), currentPageStr)}`;            
        }
        else if (currentPage > lastPage - 5 && currentPage <= lastPage) {
            for (let i = lastPage - 4; i < lastPage; i++) {
                pages += getPageButton(i.toString(), currentPageStr);
            }
        }
    }
    else {
        for (let i = 2; i < totalPages; i++) {
            pages += getPageButton(i.toString(), currentPageStr);
        }
    }
    return pages;
}

function getPageButton(pageNumber: string, currentPageIndex: string) {
    return `<li class="${listItemCss}"><button id="page-${pageNumber}" data-page="${pageNumber}" ${(pageNumber === currentPageIndex.toString()) ? "disabled" : ""} title="Go to page ${pageNumber}"
                class="cursor-pointer w-full rounded p-2 underline bg-white hover:bg-white border border-gray-light hover:border-primary-dark text-primary hover:text-primary disabled:cursor-not-allowed disabled:bg-gray-darkest disabled:text-white disabled:no-underline disabled:hover:border-gray-light">
                ${pageNumber}</button></li>`;
}

function getPreviousButton(pageNumber: string, isMobile: boolean) {
    return `<button id="page-m-previous" data-page="${pageNumber}" title="Go to previous page" class="button button-unstyled flex flex-nowrap items-center mr-4">
                <svg class="w-5 h-5 fill-primary" role="presentation"><use xlink:href="/img/icons/sprite.svg#navigate_before" /></svg> Previous</button>`;
}

function getNextButton(pageNumber: string, isMobile: boolean) {
    return `<button id="page-m-next" data-page="${pageNumber}" title="Go to next page" class="button button-unstyled flex flex-nowrap items-center ml-4">
                Next <svg class="w-5 h-5 fill-primary" role="presentation"><use xlink:href="/img/icons/sprite.svg#navigate_next" /></svg></button>`;
}
